import type { ExpenseListQuery, Page } from '@chukua/common';
import { Table, type TableColumnsType } from 'antd';
import { Receipt, SearchX } from 'lucide-react';
import { EmptyState } from '../../../shared/components/EmptyState';
import { ListSearch } from '../../../shared/components/ListSearch';
import type { ListQueryControls } from '../../../shared/hooks/use-list-query';
import type { ExpenseView } from '../expenses.api';

interface ExpensesTableProps {
  page: Page<ExpenseView>;
  columns: TableColumnsType<ExpenseView>;
  list: ListQueryControls<ExpenseListQuery>;
  isRefreshing: boolean;
}

/** Search box plus the server-paged table; the old rows stay up, dimmed, while the next page loads. */
export function ExpensesTable({ page, columns, list, isRefreshing }: ExpensesTableProps) {
  return (
    <div className="flex flex-col gap-4">
      <ListSearch value={list.query.q} placeholder="Search driver, truck, station or note" onSearch={(q) => list.setQuery({ q }, { replace: true })} />
      <Table
        rowKey="id"
        dataSource={page.items}
        columns={columns}
        loading={isRefreshing}
        scroll={{ x: 'max-content' }}
        locale={{ emptyText: list.isFiltered ? <NoMatchingExpenses /> : <NoExpensesYet /> }}
        {...list.tableProps<ExpenseView>(page.total)}
      />
    </div>
  );
}

function NoMatchingExpenses() {
  return <EmptyState icon={SearchX} title="No matching expenses" description="No expenses match this search or these filters." />;
}

function NoExpensesYet() {
  return (
    <EmptyState icon={Receipt} title="No expenses yet" description="Expenses drivers capture in the app, and ones the office records for them, appear here." />
  );
}
